'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.viewTypes = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _groupBy3 = require('lodash/groupBy');

var _groupBy4 = _interopRequireDefault(_groupBy3);

exports.processAlbums = processAlbums;
exports.processTracks = processTracks;
exports.getSortedAlbums = getSortedAlbums;
exports.getFilteredAlbums = getFilteredAlbums;
exports.getPartTracks = getPartTracks;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _utils = require('helpers/utils');

var _datetime = require('helpers/datetime');

var _projects = require('helpers/projects');

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var filteredFields = ['album', 'album2', 'artist_name', 'subject', 'title'];

var viewTypes = exports.viewTypes = {
  grid: 'grid',
  list: 'list'
};

function processTrack(_ref) {
  var track = _ref.track,
      albumId = _ref.albumId,
      _ref$album = _ref.album,
      album = _ref$album === undefined ? {} : _ref$album;

  var duration = _moment2.default.duration(Number(track.duration), 'seconds');
  var minutes = Math.floor(duration.asMinutes());
  var seconds = ('0' + duration.seconds()).substr(-2);
  track.durationTime = minutes + ':' + seconds;
  track.audioSrc = _config2.default.app.srcMasks.audio.replace('<trackName>', track.wFileName);
  track.videoSrc = _config2.default.app.srcMasks.video.replace('<trackName>', track.wFileName);
  track.albumId = albumId || album.project_id;
  if (album) {
    track.albumArtist = album.artist_name || album.subject;
    track.multPlays = album.multPlays;
    track.recipientId = album.recipient_id;
    track.contentKey = album.contentKey;
  }
  return track;
}

function processAlbum(album) {
  if (!album.project_id) {
    return album;
  }
  album.sender = album.senderName || [album.owFirstname, album.owLastname].join(' ').trim();
  album.albumName = [album.album, album.album2].join(' ').trim() || album.subject;
  album.shortSentDate = (0, _datetime.formatDate)(album.sent_date);
  album.fullSentDate = (0, _datetime.formatDateTime)(album.sent_date);
  album.expiryDateText = (0, _datetime.formatDate)(album.expiryDate);
  album.project_id = Number(album.project_id);
  album.projectId = album.project_id;
  album.recipient_id = Number(album.recipient_id);
  album.downloadable = !!album.downloadable;
  album.isPress = !!album.isPress;
  album.projectContentType = album.projectType === _projects.projectTypes.quickSend ? _projects.projectTypes.quickSend : album.audiovideo;
  album.labelName = album.senderLabel || album.label_name;
  return album;
}

function processAlbums(albums) {
  if (Array.isArray(albums)) {
    albums.map(function (album) {
      return processAlbum(album);
    });
  } else {
    processAlbum(albums);
  }

  return albums;
}

function processTracks(_ref2) {
  var tracks = _ref2.tracks,
      albumId = _ref2.albumId,
      album = _ref2.album;

  if (Array.isArray(tracks)) {
    tracks.map(function (track) {
      return processTrack({ track: track, albumId: albumId, album: album });
    });
  } else {
    processTrack({ track: tracks, albumId: albumId, album: album });
  }

  return tracks;
}

function getSortedAlbums(albums, activeOrder, order) {
  if (!activeOrder) {
    return [{ title: '', data: albums }];
  }

  var isDateOrder = activeOrder === 'sent_date' || activeOrder === 'releaseDate';
  var groupedAlbums = (0, _groupBy4.default)(albums, activeOrder);
  var sortedKeys = (0, _keys2.default)(groupedAlbums).sort(function (keyA, keyB) {
    var sign = order[activeOrder] === 'asc' ? 1 : -1;
    var res = sign;

    if (isDateOrder) {
      var dateA = new Date(keyA || null);
      var dateB = new Date(keyB || null);
      res = dateA > dateB ? sign : -sign;
    } else if (typeof keyA === 'string' && typeof keyB === 'string') {
      res = keyA.toLowerCase() > keyB.toLowerCase() ? sign : -sign;
    } else {
      res = keyA > keyB ? sign : -sign;
    }

    return res;
  });

  var sortedAlbums = [];
  sortedKeys.map(function (key) {
    var title = key;
    if (title && isDateOrder) {
      title = title ? (0, _moment2.default)(new Date(title)).format(_datetime.dateFormat.date) : '';
    }
    sortedAlbums.push({ id: (0, _uuid2.default)(), title: title, data: groupedAlbums[key] });
  });

  return sortedAlbums;
}

function getFilteredAlbums(albums, kw) {
  return (0, _utils.filterObjectsByKws)({ objects: albums, fields: filteredFields, kw: kw });
}

function getPartTracks(allTracks) {
  var parts = [];
  var tracks = {};

  allTracks.map(function (track, index) {
    var part = track.part || 0;

    if (!tracks[part]) {
      tracks[part] = [];
    }
    tracks[part].push(index);

    if (!parts.includes(part)) {
      parts.push(part);
    }
  });

  return { tracks: tracks, parts: parts };
}


//////////////////
// WEBPACK FOOTER
// ./src/helpers/Playlists.js
// module id = 214
// module chunks = 1